import type { ComponentProps } from 'react'
import type { TourStyledNonSignatureProductTypeInfoModalResult } from './TourStyledNonSignatureProductTypeInfoModal'
import TourStyledNonSignatureProductTypeInfoModal from './TourStyledNonSignatureProductTypeInfoModal'
import type { TourStyledSignatureSeriesProductTypeInfoModalResult } from './TourStyledSignatureSeriesProductTypeInfoModal'
import TourStyledSignatureSeriesProductTypeInfoModal from './TourStyledSignatureSeriesProductTypeInfoModal'
import TourStyledInsiderSeriesProductTypeInfoModal from './TourStyledInsiderSeriesProductTypeInfoModal'

export type TourStyledProductTypeInfoModalResult = TourStyledSignatureSeriesProductTypeInfoModalResult | TourStyledNonSignatureProductTypeInfoModalResult

interface Props extends ComponentProps<typeof TourStyledSignatureSeriesProductTypeInfoModal>, Omit<ComponentProps<typeof TourStyledNonSignatureProductTypeInfoModal>, 'productType'> {
  productType: App.Tours.V2ProductTypeStyled
}

function TourStyledProductTypeInfoModal({
  productType,
  ...rest
}: Props) {
  if (productType === 'signature_series_tour') {
    return <TourStyledSignatureSeriesProductTypeInfoModal {...rest} />
  }
  if (productType === 'insider_series_tour') {
    return <TourStyledInsiderSeriesProductTypeInfoModal {...rest} />
  }

  return <TourStyledNonSignatureProductTypeInfoModal {...rest} productType={productType} />
}

export default TourStyledProductTypeInfoModal
